<template>
  <el-header>
    <div class="left" v-if="showTitle" @click="toMain()">
      <img src="../assets/images/logo-min.png" />
      <p>智能配电监控云平台</p>
    </div>
    <!-- v-loading="" -->
    <div class="right">
      <img src="../assets/images/person.png" />
      <p>欢迎 {{ name }}</p>
      <div class="fixed-box" :style="{right:(isOpenAdmin?'145px':'85px')}" v-if="totalNum>0">
        <div class="tips-box" :class="[{'r1': shrinkPacket}, {'r2': !shrinkPacket}]" :max="99" @click="toWarn">{{totalNum>99?'99+':totalNum}}</div>
        <!-- <el-badge :value="totalNum" :class="[{'r1': shrinkPacket}, {'r2': !shrinkPacket}]" v-if="totalNum>0" :max="99" @click="toWarn"> -->
        <img class="rotate" @click="toWarn" src="../assets/images/icon/message.png" />
        <!-- </el-badge> -->
      </div>
      <div class="seat-box"></div>
      <!-- <el-badge :value="totalNum" v-if="totalNum>0" :max="99" class="item" @click="toWarn">
        <img src="../assets/images/icon/message.png" @click="toWarn" />
      </el-badge> -->
      <img src="../assets/images/icon/icon2.png" v-if="isOpenAdmin" @click="toAdmin" />
      <img src="../assets/images/icon/logout.png" @click="logout" />
    </div>
  </el-header>
</template>

<script>
export default {
  name: "headerMain",
  data() {
    return {
      name: "",
      timer: 0,
      shrinkPacket: false,
      // headerLoading:false,
      isOpenAdmin: false,
    };
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  mounted() {
    this.name = JSON.parse(this.$getCookie("userInfo")).userName;
    this.userId = JSON.parse(this.$getCookie("userInfo")).userId;
    // this.headerLoading=false
    this.$nextTick(() => {
      setTimeout(() => {
        let resourceIds = this.$getCookie("resourceIds").split(",");
        let manageIds = ["8", "9", "10", "11", "99"];
        this.isOpenAdmin =
          manageIds.filter(function (val) {
            return resourceIds.indexOf(val) > -1;
          }).length > 0
            ? true
            : false;
        this.totalNum = this.$store.state.totalNum;
        // this.headerLoading=true
        // console.log(this.totalNum)
      }, 500);
    });
    if (this.alarmStatus) {
      //  console.log('0000000')
      this.startRotate();
    } else {
      // console.log('11111')
      clearInterval(this.timer);
    }
  },
  computed: {
    // totalNum() {
    //   return this.$store.state.forcastNum;
    // },
    totalNum:{
      get(){
        return this.$store.state.totalNum;
        },
        set(val){
         this.$store.state.totalNum=val;
        }
      },
    alarmStatus() {
      return this.$store.state.alarmStatus;
    },
  },
  watch: {
    alarmStatus(v) {
      console.log(v);
      if (v) {
        this.startRotate();
      } else {
        clearInterval(this.timer);
      }
    },
  },
  methods: {
    toAdmin() {
      this.$router.push("/super");
    },
    toMain() {
      this.$router.push("/project");
    },
    toWarn() {
      this.$router.push("/warn");
    },
    startRotate() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.shrinkPacket = !this.shrinkPacket;
      }, 270);
    },
    logout() {
      this.$http.post("/bma-auth-service/sys/signOut").then((res) => {
        this.alarmStatus=false
        window.localStorage.clear();
        this.$clearAllCookie();
        this.$disconnect();
        this.$store.commit("setAlarmStatus", false);
        localStorage.stop = true;
        this.$router.push("/");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.fixed-box {
  position: fixed;
  top: 0px;
  width: 30px;
  height: 30px;
  // .el-badge {
  //   margin-right: 20px;
  img {
    width: 30px;
    height: 30px;
    margin-top: -4px;
  }
  .r1 {
    transform: translateY(6px);
  }
  .r2 {
    transform: translateY(8px);
  }
  .tips-box {
    display: inline-block;
    float: left;
    height: 18px;
    padding: 0 6px;
    line-height: 19px;
    font-size: 12px;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 10px;
    white-space: nowrap;
    background-color: #f56c6c;
    margin-left: 15px;
  }
  // }
}
.seat-box {
  width: 30px;
  height: 30px;
  margin: 0px 10px;
}
.el-header {
  height: 78px;
  background: #fff;
  padding: 0 25px;
  display: flex;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  z-index: 10;
  .left {
    display: flex;
    cursor: pointer;
    align-items: center;
    img {
      width: 37px;
      margin-right: 12px;
    }
    p {
      font-size: 18px;
      font-weight: 500;
      color: #161820;
      opacity: 1;
    }
  }
  .right {
    display: flex;
    align-items: center;
    img {
      //  width: 37px;
      width: 30px;
      margin-right: 20px;
      cursor: pointer;
      &:not(:first-of-type) {
        width: 30px;
        height: 30px;
      }
    }
    // .el-badge {
    //   margin-right: 20px;
    //   img {
    //     width: 30px;
    //     height: 30px;
    //     margin: 0;
    //   }
    // }
    p {
      line-height: 27px;
      color: #445a5a;
      margin-right: 10px;
    }
  }
}
</style>
